// @ts-nocheck
import React from 'react';
import EventManagementChecklists from '@/pages/admin/event-management/EventManagementChecklists';

const DemoChecklists: React.FC = () => {
  return <EventManagementChecklists />;
};

export default DemoChecklists;
